import { ToggleButtonProps } from '@mui/material';

import { useFormattedValue } from '../../../../../../common/eye-params/hooks';
import { EyeParamsType } from '../../../../../../../graphql/lenses/models/get-lenses.models';
import { IOptions } from '../../../../../../common/select';

interface IParamItemsProps {
  paramValues: number[];
  property: EyeParamsType;
  isOrder: boolean;
}

export const getParamItems = ({ paramValues, property }: IParamItemsProps): ToggleButtonProps[] => {
  const { getFormattedValue } = useFormattedValue();

  return paramValues.map((paramValue) => ({
    children: getFormattedValue(String(paramValue), property),
    value: String(paramValue),
  }));
};

export const getParamSelectItems = ({ paramValues, property }: IParamItemsProps): IOptions[] => {
  const { getFormattedValue } = useFormattedValue();

  return paramValues.map((paramValue) => ({
    value: String(paramValue),
    label: getFormattedValue(String(paramValue), property),
  }));
};
